var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"42","height":"43","viewBox":"0 0 42 43","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('ellipse',{attrs:{"opacity":"0.9","rx":"20.5","ry":"21.5","transform":"matrix(-1 0 0 1 21 21.5)","fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }